import React from "react";
import styles from "./requestEditModal.scss";
import close from "../../../../assets/images/close-icon.svg";

const requestEditModal = ({ onHide, modalClick }) => (
  <div className={styles.modalcontainer}>
    <img src={close} className={styles.closebutton} onClick={() => onHide()} />
    <div className={styles.modalcontent}>
      <div className={styles.header}>
        <h2 className={styles.title}>Request Edits to SOW</h2>
      </div>
      <div className={styles.divider}>
        <div className={styles.top} />
        <div className={styles.bottom} />
      </div>
      <div className={styles.intro}>
        <div>
          <textarea id="message" className={styles.textField} />
        </div>
        <div>
          <button
            className={styles.acceptButton}
            onClick={() => {
              modalClick(document.getElementById("message").value);
              onHide();
            }}
          >
            SEND
          </button>
        </div>
        <div>
          <button className={styles.cancelButton} onClick={() => onHide()}>
            {" "}
            Cancel{" "}
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default requestEditModal;



// WEBPACK FOOTER //
// ./src/routes/employer/memberProposal/components/requestEditModal.js